// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Row from 'components/common/Row';
import Col from 'components/common/Col';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import StudioDashboard from './StudioDashboard';
import InvoicesTable from './InvoicesTable';
import OrganizationTransactions from './OrganizationTransactions';

class AppHome extends React.PureComponent {
  render() {
    return (
      <PageContainer>
        <div>
          <StudioDashboard history={this.props.history} />
          <Row gutter={15} align="flex-start">
            <Col xs={24} md={8}>
              <OrganizationTransactions />
            </Col>
            <Col xs={24} md={16}>
              <InvoicesTable currentUser={this.props.currentUser} windowWidth={this.props.windowWidth} />
            </Col>
          </Row>
        </div>
      </PageContainer>
    );
  }
}

export default AppHome;



// WEBPACK FOOTER //
// ./src/routes/app-home/index.js